/**
 * @generated SignedSource<<5c30ce8bda8bec22b550a077773989eb>>
 * @relayHash 9748ba602b2febc685e72253a522da4d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9748ba602b2febc685e72253a522da4d

import type { ConcreteRequest } from 'relay-runtime';
export type useCopilotAgentDefaultBranchRepositoryQuery$variables = {
  id: string;
};
export type useCopilotAgentDefaultBranchRepositoryQuery$data = {
  readonly node: {
    readonly databaseId?: number | null | undefined;
    readonly defaultBranchRef?: {
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type useCopilotAgentDefaultBranchRepositoryQuery = {
  response: useCopilotAgentDefaultBranchRepositoryQuery$data;
  variables: useCopilotAgentDefaultBranchRepositoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCopilotAgentDefaultBranchRepositoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Ref",
                "kind": "LinkedField",
                "name": "defaultBranchRef",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Repository",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCopilotAgentDefaultBranchRepositoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Ref",
                "kind": "LinkedField",
                "name": "defaultBranchRef",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Repository",
            "abstractKey": null
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "9748ba602b2febc685e72253a522da4d",
    "metadata": {},
    "name": "useCopilotAgentDefaultBranchRepositoryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d507f64d80526dd7fa065bad1d2ae573";

export default node;
